<form class="mt-0" [attr.data-testid]="formTestId" [formGroup]="attributeDefinitionForm" (ngSubmit)="submitForm()">
  <div class="flex flex-col col-12 mb-2 text-wr">
    <div class="row">
      <div class="flex flex-col col-12 mb-4">
        <h2 [attr.data-testid]="'add-' + entityName + 'attribute-details-title'" class="border-b pb-3">
          {{ (translationPrefix + '.' + entityName.toUpperCase() + '_ATTRIBUTE_DEFINITIONS') | translate }}
        </h2>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [class.disabled]="mode === 'edit'">
        <label class="block text-sm" for="attributeCode">
          {{ (translationPrefix + '.ATTRIBUTE_CODE') | translate }}
          <i class="icon-required-field"></i>
        </label>
        <input id="attributeCode" type="text" formControlName="attributeCode" autocomplete="off"
          placeholder="{{ (translationPrefix + '.ATTRIBUTE_CODE_PLACEHOLDER') | translate }}">
        @if (attributeDefinitionForm.get('attributeCode')?.invalid && attributeDefinitionForm.get('attributeCode')?.touched) {
          <small class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
        }
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-2 col-xxl-2 justify-end">
        <button type="button" class="p-element btn borderless-btn btn-icon icon-translate"
          (click)="toggleAttributeTranslations()">
          {{ (translationPrefix + '.TRANSLATE') | translate }}
        </button>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3" [class.disabled]="mode === 'edit'">
        <label class="block text-sm" for="dataType">
          {{ (translationPrefix + '.DATA_TYPE') | translate }}
        </label>
        <app-custom-dropdown data-testid="data-type"
          [placeholder]="(translationPrefix + '.SELECT_DATA_TYPE_PLACEHOLDER') | translate"
          optionLabel="label" optionValue="value" [isMultiselect]="false" [showSelectionChips]="true" [showClear]="false"
          [showSearchbox]="false" [searchMode]="'local'" [options]="dataTypeOptions" formControlName="dataType">
        </app-custom-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
        <label class="block text-sm">
          {{ (translationPrefix + '.ALLOW_MULTIPLE_VALUES') | translate }}
        </label>
        <div class="flex flex-wrap gap-4 mt-3">
          <div class="flex align-items-center">
            <p-radioButton inputId="allowMultipleValuesYes" formControlName="allowMultipleValues" [value]="true" name="allowMultipleValues">
            </p-radioButton>
            <label for="allowMultipleValuesYes" class="ml-2">
              {{ (translationPrefix + '.YES') | translate }}
            </label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton inputId="allowMultipleValuesNo" formControlName="allowMultipleValues" [value]="false" name="allowMultipleValues">
            </p-radioButton>
            <label for="allowMultipleValuesNo" class="ml-2">
              {{ (translationPrefix + '.NO') | translate }}
            </label>
          </div>
        </div>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
        <label class="block text-sm">
          {{ (translationPrefix + '.CHANGES_OVER_TIME') | translate }}
        </label>
        <div class="flex flex-wrap gap-4 mt-3">
          <div class="flex align-items-center">
            <p-radioButton inputId="changesOverTimeYes" formControlName="changesOverTime" [value]="true" name="changesOverTime">
            </p-radioButton>
            <label for="changesOverTimeYes" class="ml-2">
              {{ (translationPrefix + '.YES') | translate }}
            </label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton inputId="changesOverTimeNo" formControlName="changesOverTime" [value]="false" name="changesOverTime">
            </p-radioButton>
            <label for="changesOverTimeNo" class="ml-2">
              {{ (translationPrefix + '.NO') | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <hr role="presentation" class="w-full border-t">
    @if (showAttributeTranslations) {
      <div class="row mt-3" [formGroup]="attributeTranslationsGroup">
        <div class="col-12">
          <div class="p-4 translations-wr">
            <div class="mb-4 text-sm uppercase">
              {{ (translationPrefix + '.TRANSLATIONS') | translate }}
            </div>
            <div class="row">
              @for (language of languages; track language) {
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4">
                  <label class="block text-sm">
                    {{ language.language | translate }}
                  </label>
                  <input type="text" [formControlName]="language.code" autocomplete="off">
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (isFixedValuesType || valueCodes.length > 0) {
      <div formArrayName="valueCodes">
        @for (item of valueCodes.controls; track item; let i = $index) {
          <div
            class="row mt-5"
            [formGroupName]="i">
            <div class="field-wr flex flex-col col-12 col-md-6 col-xl-4" [class.disabled]="mode === 'edit' && item.get('newValue')?.value">
              <label class="block text-sm" [for]="'valueCode-' + i">
                {{ (translationPrefix + '.VALUE_CODE') | translate }}
                #{{ i + 1 }}
                <i class="icon-required-field"></i>
                <button
                  data-testid="remove-definition-value"
                  class="btn borderless-btn btn-icon icon-trash"
                  pTooltip="{{ (translationPrefix + '.BTN_REMOVE_DEFINITION_VALUE') | translate }}"
                  tooltipPosition="top"
                  (click)="removeValueCode(i)">
                </button>
              </label>
              <input
                [id]="'valueCode-' + i"
                type="text"
                formControlName="code"
                autocomplete="off"
                placeholder="{{ (translationPrefix + '.VALUE_CODE_PLACEHOLDER') | translate }}">
              @if (item.get('code')?.invalid && item.get('code')?.touched) {
                <small class="p-error">
                  {{ 'FORMS.MANDATORY_FIELD' | translate }}
                </small>
              }
            </div>
            <div class="field-wr flex flex-col col-12 col-md-3 col-xl-2">
              <label class="block text-sm">
                {{ (translationPrefix + '.IS_ACTIVE') | translate }}
              </label>
              <div class="flex flex-wrap gap-4 mt-3">
                <div class="flex align-items-center">
                  <p-radioButton
                    [inputId]="'valueCodeisActiveYes-' + i"
                    [name]="'codeIsActive-' + i"
                    [ngModel]="item.get('codeIsActive')?.value"
                    [ngModelOptions]="{ standalone: true }"
                    [value]="true"
                    (ngModelChange)="item.get('codeIsActive')?.setValue($event)">
                  </p-radioButton>
                  <label [for]="'valueCodeisActiveYes-' + i" class="ml-2">
                    {{ (translationPrefix + '.YES') | translate }}
                  </label>
                </div>
                <div class="flex align-items-center">
                  <p-radioButton
                    [inputId]="'valueCodeisActiveNo-' + i"
                    [name]="'codeIsActive-' + i"
                    [ngModel]="item.get('codeIsActive')?.value"
                    [ngModelOptions]="{ standalone: true }"
                    [value]="false"
                    (ngModelChange)="item.get('codeIsActive')?.setValue($event)">
                  </p-radioButton>
                  <label [for]="'valueCodeisActiveNo-' + i" class="ml-2">
                    {{ (translationPrefix + '.NO') | translate }}
                  </label>
                </div>
              </div>
            </div>
            <div class="field-wr flex flex-col col-12 col-md-3 col-xl-2 justify-end">
              <div class="flex flex-wrap items-center gap-4">
                <button
                  type="button"
                  class="p-element btn borderless-btn btn-icon icon-translate"
                  (click)="toggleValueTranslations(i)">
                  {{ (translationPrefix + '.TRANSLATE') | translate }}
                </button>
              </div>
            </div>
            @if (item.get('showTranslations')?.value) {
              <div
                class="col-12 mt-3"
                [formGroup]="getValueTranslationsGroup(i)">
                <div class="p-4 translations-wr">
                  <div class="mb-4 text-sm uppercase">
                    {{ (translationPrefix + '.TRANSLATIONS') | translate }}
                  </div>
                  <div class="row">
                    @for (language of languages; track language) {
                      <div
                        class="field-wr flex flex-col col-12 col-md-6 col-lg-4"
                        >
                        <label class="block text-sm">
                          {{ language.language | translate }}
                        </label>
                        <input
                          type="text"
                          [formControlName]="language.code"
                          autocomplete="off">
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      @if (isFixedValuesType) {
        <div class="row mt-3">
          <div class="col-12">
            <button type="button" class="btn outline-btn filters-btn" (click)="addValueCode()">{{ (translationPrefix + '.ADD_VALUE') | translate }}</button>

            @if (attributeDefinitionForm.errors?.['valueCodeRequired'] && attributeDefinitionForm.touched) {
              <div class="mt-2">
                <small class="p-error">
                  {{ (translationPrefix + '.AT_LEAST_ONE_VALUE_CODE_REQUIRED') | translate }}
                </small>
              </div>
              }
            </div>
          </div>
        }
      }
  </div>
</form>
